<template>
  <div>
    <template v-if="!retrieveData.length">
      <ul class="pz_one">
        <component ref="componentRef" :is="getComponent" v-bind="getConfig" />
        <li>
          <!-- <button class="btn">{{ getBtnText }}<br /><span>{{ getSubBtnText }}</span></button> -->
          <a-button type="primary" class="btn" block @click="submit" :loading="submitLoading">
            {{ getBtnText }}<br /><span>{{ getSubBtnText }}</span>
          </a-button>
        </li>
        <li class="tishi">
          <div v-html="getConfig.tip"></div>
        </li>
      </ul>
    </template>
    <!-- 列表 -->
    <template v-else>
      <ul class="pz_two">
        <li v-for="(page, index) in pagedData" :key="index" @click="getDetail(page)">
          <p class="type">{{ page.certificateName }}</p>
          <p>{{ page.company }}</p>
          <p>{{ page.name }}</p>
          <p>{{ page.title }}</p>
        </li>
      </ul>
      <div class="page">
        <span @click="prevPage">上一页</span>
        <div class="fan" @click="back">返回</div>
        <span @click="nextPage">下一页</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { translateConditionToZhCN } from "../../utils"
import { showModal, validatePhoneNumber, validateEmail } from "@/utils/util";
import DynamicVerification from "./components/DynamicVerification.vue";
import SingleCondition from "./components/SingleCondition.vue";
import FeatureMatching from "./components/FeatureMatching.vue";
import FuzzyQuery from "./components/FuzzyQuery.vue";
export default {
  name: "Retrieve",
  components: {
    DynamicVerification,
    SingleCondition,
    FeatureMatching,
    FuzzyQuery,
  },
  data() {
    return {
      retrieveData: [], // 找回的列表
      currentPage: 0, // 当前页码
      itemsPerPage: 3, // 每页显示的元素数量
      submitLoading: false,
    };
  },
  computed: {
    ...mapGetters("receiptStore", ["getConfig"]),
    modalSettings() {
      return this.getConfig.modalSettings || false;
    },
    getBtnText() {
      if (
        this.getConfig.buttonSettings == null ||
        !this.getConfig.buttonSettings
      ) {
        return "找回";
      }
      return this.getConfig.buttonSettings.btnText || "找回";
    },
    getSubBtnText() {
      if (
        this.getConfig.buttonSettings == null ||
        !this.getConfig.buttonSettings
      ) {
        return "Search";
      }
      return this.getConfig.buttonSettings.subBtnText || "Search";
    },
    getComponent() {
      if (this.getConfig === null || !this.getConfig) return;
      switch (this.getConfig.verifyMode) {
        case 1: return "DynamicVerification";
        case 2: return "SingleCondition";
        case 3: return "FeatureMatching";
        case 4: return "FuzzyQuery";
        default: return;
      }
    },
    pagedData() {
      // 使用computed计算属性来获取分页后的数据
      const start = this.currentPage * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.retrieveData.slice(start, end);
    },
  },
  methods: {
    translateConditionToZhCN,
    validatePhoneNumber,
    validateEmail,
    // 上一页
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage < this.retrieveData.length / this.itemsPerPage) {
        this.currentPage += 1;
      }
    },
    // 获取详情
    getDetail(item) {
      const alias = this.$route.query.alias;
      this.$router.push(
        `/receipt/detail?alias=${alias}&hax=${encodeURIComponent(item.id)}`
      );
    },
    // 返回
    back() {
      this.retrieveData = [];
    },
    // 提交
    async submit() {
      const { getComponent, $post, $message, $route, validatePhoneNumber, validateEmail, getConfig, translateConditionToZhCN } = this;

      const formData = this.$refs.componentRef.formData;
      const { alias } = $route.query;
      const modalSettings = this.modalSettings;

      if (!formData) {
        $message.warning("表单数据未获取到，请检查组件引用。");
        return;
      }

      const checkField = (field, message, validators = []) => {
        if (!formData[field] || formData[field].trim() === "") {
          $message.warning(message);
          return false;
        }
        if (validators.length > 0) {
          const [validatePhoneNumber, validateEmail] = validators;
          if (!validatePhoneNumber(formData[field]) && !validateEmail(formData[field])) {
            $message.warning(message);
            return false;
          }
        }
        return true;
      };

      let valid = true;

      switch (getComponent) {
        case "DynamicVerification":
          valid = checkField("text", "请输入手机号码或邮箱") &&
            checkField("code", "请输入验证码") &&
            checkField("text", "请输入正确的手机号码或邮箱", [validatePhoneNumber, validateEmail]);
          break;
        case "SingleCondition":
        case "FuzzyQuery":
          valid = checkField("keyWord", "请输入查询条件");
          break;
        case "FeatureMatching":
          const conditionSettings = getConfig.conditionSettings;
          valid = conditionSettings.every(it => {
            return formData[it] && formData[it].trim() !== "";
          });
          if (!valid) {
            conditionSettings.forEach(it => {
              if (!formData[it] || formData[it].trim() === "") {
                $message.warning(`请输入${translateConditionToZhCN(it)}`);
              }
            });
          }
          break;
        default:
          $message.warning("未知的组件类型，请检查配置。");
          return;
      }

      if (!valid) return;

      this.submitLoading = true;
      const postBody = { alias, ...formData };

      try {
        const res = await $post("/api/BizReceipt/Verificationng", postBody);

        if (res.code === 200) {
          if (!res.data || !res.data.length) {
            if (modalSettings) {
              showModal(modalSettings);
              return;
            }
            $message.warning("系统未检测到您的注册信息");
            return;
          }
          $message.success("验证成功");

          if (res.data.length === 1) {
            this.$router.push(`/receipt/detail?alias=${alias}&hax=${encodeURIComponent(res.data[0].id)}`);
          }

          this.retrieveData = [...res.data];
        } else {
          $message.error(res.message);
        }
      } catch (error) {
        $message.error("请求失败，请稍后重试。");
        console.error("API call failed:", error);
      } finally {
        this.submitLoading = false;
      }
    },
    // 访问过历史，自动跳转详情
    jumpDirectlyToDetails() {
      const localData = JSON.parse(localStorage.getItem("detail") || false);
      const target = localStorage.getItem("target") || false;
      // 访问的相同链接才进行跳转
      if (!!localData && !!target && target === this.$route.fullPath) {
        const regex = /receipt\/detail\?alias=(\d+)(&|$|\b)/;
        const match = target.match(regex);
        if (match && match[1]) {
          const alias = this.$route.query.alias;
          const aliasValue = match[1];
          if (alias === aliasValue) {
            const hash = target.split("#");
            this.$router.push(hash.pop());
          } else {
            console.log("拦截跳转");
          }
        } else {
          console.log("No match found");
        }
      }
    },
  },
  mounted() {
    this.jumpDirectlyToDetails();
  },
};
</script>

<style>
.example {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
}
</style>
